<script setup lang="ts">
import { storeToRefs } from "pinia";
import { useMaintain } from "@/stores/maintain";
import messageImage_1699243054823 from "@image/memberFunction/maintain/messageImage_1699243054823.jpg";
const Maintain = useMaintain();

const { MaintainMsg } = storeToRefs(Maintain);
</script>
<template>
  <div
    class="min-h-[100dvh] overflow-hidden h-full bg-white flex justify-center items-center px-[6vw]">
    <div class="relative">
      <p
        class="z-10 absolute left-1/2 -translate-x-1/2 top-[20%] font-bold text-[24px] h-full">
        {{ MaintainMsg }}
      </p>
      <!-- <p
        class="z-10 absolute left-1/2 -translate-x-1/2 top-[20%] font-bold text-[24px] h-full"
      >
        維護中
      </p> -->
      <img
        v-img-src="messageImage_1699243054823"
        alt=""
        class="w-[80%] relative left-1/2 -translate-x-1/2" />
    </div>
  </div>
</template>
